import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Container, useMediaQuery } from "@material-ui/core";
import "./promotional-footer.css";
import {
  PostBlogPure,
  MiniCardTemplatePure,
  DialogTermsCond,
} from "../../pures";
import { phoneIcon } from "../../../assets/logos/icons";
import { webIcon } from "../../../assets/logos/icons";
import { acercaDeGovo, acercaDeGovo240 } from "../../../assets/logos/icons";
import { LocalStorageService } from "../../../services";

const PromotionalFooterPure = () => {
  const { t } = useTranslation();
  const showFullGif = useMediaQuery("(max-width:1414px)");
  const showMidGif = useMediaQuery("(max-width: 937px");
  const showSmallGif = useMediaQuery("(max-width:280px)");
  const [showFullOrSmallGif, setShowFullOrSmallGif] = useState(true);
  const [showFooter, setShowFooter] = useState(false)
  const localStorageService = new LocalStorageService()

  useEffect(() => {
    const showFooter = localStorageService.getLocalStorageItem("footerEnabled")
    setShowFooter(showFooter)
  }, [])

  useEffect(() => {
    if (showFullGif) {
      setShowFullOrSmallGif(false);
      if (showMidGif) {
        setShowFullOrSmallGif(true);
        if (showSmallGif) {
          setShowFullOrSmallGif(false);
        }
      }
    } else {
      setShowFullOrSmallGif(true);
    }
  }, [showFullOrSmallGif, showMidGif, showFullGif, showSmallGif]);

  const [modalTermsCond, setModalTermsCond] = useState(null);

  const openModalTermsCond = (value) => {
    setModalTermsCond(value);
  };
  const titleContact = t("promotionalFooterPure.titleContact");
  const titlePostBlog = t("promotionalFooterPure.titlePostBlog");
  return (showFooter &&
    <div>
      <Grid
        xs={12}
        lg={12}
        md={12}
        sm={12}
        className="promotionalFooterPure-footer"
      >
        <div className="promotionalFooterPure-contact-container">
          <p className="promotionalFooterPure-title-footer-miniCard">
            {titleContact}
          </p>
          <div className="promotionalFooterPure-card-contact">
            <a
              href={`https://wa.me/${process.env.REACT_APP_PHONE_NUMBER}?text=${encodeURI(t("whatsapp_default_text"))}`}
              target={"_blank"}
              className="promotionalfooterPure-contact-icons"
            >
              <img className="promotionalFooterPure-icon" src={phoneIcon} />
              <p className="promotionalFooterPure-title-footer-miniCard">
                {process.env.REACT_APP_PHONE_NUMBER_FOOTER}
              </p>
            </a>
            <div className="promotionalFooterPure-separation"></div>
            <a
              href="https://govo.digital"
              target={"_blank"}
              className="promotionalfooterPure-contact-icons"
            >
              <img className="promotionalFooterPure-icon" src={webIcon} />
              <p className="promotionalFooterPure-title-footer-miniCard">
                govo.digital
              </p>
            </a>
          </div>
        </div>
        <PostBlogPure footer={true} />
        <div className="promotionalFooterPure-promotions-container">
          {/* <Grid
        item
        xs={12}
        lg={12}
        md={12}
        sm={12}
        es={12}
        className="promotionalFooterPure-card-footer-promotion"
        > */}
          {/* <a href="https://akubica.com/solucion-easycap/" target="_blank">
          <img
          src="https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/footer_contact_A3_APPS.gif"
          alt="Ad"
          className="promotionalFooterPure-button-easycap"
          />
          </a> */}
          <img
            src={showFullOrSmallGif ? acercaDeGovo : acercaDeGovo240}
            alt={"govo-promotions"}
            className="promotionalFooterPure-button-hibou"
          />
          {/* </Grid> */}
        </div>
      </Grid>

      <DialogTermsCond
        modalTermsCond={modalTermsCond}
        openModalTermsCond={openModalTermsCond}
      />
    </div>
  )
};

export { PromotionalFooterPure as default };
